import Dialog from '../../../common/Dialog'
import SearchBar from '../SearchBar'
import './SearchBarDialog.css'

const SearchBarDialog = ({
  query,
  setQuery,
  isVisible,
  onClose,
  onSearch,
  ignoreMobileBehavior = true
}) => {
  return (
    <Dialog
      isVisible={isVisible}
      onCancel={onClose}
      className='mobile-search-dialog bottom-sheet'
      footerActions={null}
      width={1000}
      centered={false}
      transitionName=''
      maskTransitionName=''
      style={{
        margin: 0,
        paddingBottom: 0,
        top: 'auto',
        bottom: 0,
        position: 'fixed',
        width: '100%',
        maxWidth: '100%'
      }}
    >
      <div className='mobile-search-dialog-content'>
        <SearchBar
          query={query}
          setQuery={setQuery}
          onSearch={onSearch}
          ignoreMobileBehavior={ignoreMobileBehavior}
          viewMode='list'
          onClickSuggestion={onClose}
          onClickSearchButton={onClose}
        />
      </div>
    </Dialog>
  )
}

export default SearchBarDialog
